import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const UserFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.82 6.8C15.82 8.92 14.12 10.62 12 10.62C9.88 10.62 8.18 8.92 8.18 6.8C8.18 4.68 9.88 2.98 12 2.98C14.12 2.98 15.82 4.68 15.82 6.8ZM12 11.64C15.6 11.64 18.68 14.62 18.68 19H5.32C5.32 14.62 8.4 11.64 12 11.64Z" />
    </SvgIcon>
  );
});
